import { render, staticRenderFns } from "./PostaGuverciniChannelDetail.vue?vue&type=template&id=776c7a0a&scoped=true"
import script from "./PostaGuverciniChannelDetail.vue?vue&type=script&lang=js"
export * from "./PostaGuverciniChannelDetail.vue?vue&type=script&lang=js"
import style0 from "./PostaGuverciniChannelDetail.vue?vue&type=style&index=0&id=776c7a0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776c7a0a",
  null
  
)

export default component.exports